/* Common Imports */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component imports */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

/* Data Imports */
import SellerFaqContent from "./data/SellerFaqContent";

const useStyles = makeStyles((theme) => ({
  accordion: {
    boxShadow:
      "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
    marginTop: "0.5rem",
    borderRadius: "4px",
  },
  accordionHeader: {
    background: "#fafafa",
  },
  accordionTitle: {
    fontSize: "1rem",
    letterSpacing: "0.03rem",
  },
  accordionContent: {
    color: "#666666",
    fontSize: "1rem",
    lineHeight: "1.4rem",
    letterSpacing: "0.025rem",
  },
}));

const SellerFaqs = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <span id="back-to-top-anchor"></span>
      {SellerFaqContent.map((object, key) => {
        return (
          <Accordion key={key} className={classes.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classes.accordionHeader}
            >
              <Typography
                variant="body1"
                component="span"
                className={classes.accordionTitle}
              >
                {object.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                component="span"
                className={classes.accordionContent}
              >
                {object.content}
              </Typography>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </React.Fragment>
  );
};

export default SellerFaqs;
